module.exports = __webpack_public_path__ + "img/financial-header-doc-1.190e4d5c.jpg";